import _ from 'lodash';
import axios from 'axios';
import configService from '@/services/configService';
import utils from '@/helper/utils';


export default {
  async listSubmissionsById({ query = {} } = {}) {
    const pickedQuery = _.pick(query, [
      'q',
      'taskId'
    ]);
    let url = `${configService.get('apiUrl')}/cstSubmission/cstId`;
    if (pickedQuery) {
      url += `?${utils.toQueryStrings(pickedQuery)}`;
    }

    return axios
      .get(url, {})
      .then(response => {
        return response.data;
      })
      .catch(e => {
        throw e;
      });
  }
};
